import { createReducer } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import {
  clearReconciliationRunDetail,
  clearReconciliationRunItemDetail,
  fetchReconciliationRunDetail,
  fetchReconciliationRunExportJson,
  fetchReconciliationRunItemDetail,
  fetchReconciliationRuns,
} from './reconciliation.actions';
import { ReconciliationState } from './reconciliation.types';

const initialState: ReconciliationState = {
  reconciliationRuns: [],
  totalReconciliationRuns: 0,
  fetchReconciliationRunsStatus: fetchStatuses.idle,
  error: null,
  activeRunDetail: null,
  runDetailItems: [],
  runDetailTotalItems: 0,
  fetchRunDetailStatus: fetchStatuses.idle,
  runDetailError: null,
  exportReconciliationRunStatus: fetchStatuses.idle,
  reconciliationItemDetail: null,
  fetchReconciliationItemDetailStatus: fetchStatuses.idle,
  reconciliationItemDetailError: null,
};

export const reconciliationReducer = createReducer(initialState, (builder) => {
  builder.addCase(fetchReconciliationRuns.pending, (state) => {
    state.fetchReconciliationRunsStatus = fetchStatuses.pending;
  });
  builder.addCase(fetchReconciliationRuns.fulfilled, (state, action) => {
    state.reconciliationRuns = action.payload.data.items;
    state.totalReconciliationRuns = action.payload.data.totalItems;
    state.fetchReconciliationRunsStatus = fetchStatuses.success;
    state.error = null;
  });
  builder.addCase(fetchReconciliationRuns.rejected, (state, action) => {
    state.fetchReconciliationRunsStatus = fetchStatuses.rejected;
    state.error = action.error;
  });

  builder.addCase(fetchReconciliationRunDetail.pending, (state) => {
    state.fetchRunDetailStatus = fetchStatuses.pending;
    state.runDetailError = null;
    state.activeRunDetail = null;
    state.runDetailItems = [];
    state.runDetailTotalItems = 0;
  });
  builder.addCase(fetchReconciliationRunDetail.fulfilled, (state, action) => {
    state.activeRunDetail = action.payload.data.run;
    state.runDetailItems = action.payload.data.items;
    state.runDetailTotalItems = action.payload.data.totalItems;
    state.fetchRunDetailStatus = fetchStatuses.success;
    state.runDetailError = null;
  });
  builder.addCase(fetchReconciliationRunDetail.rejected, (state, action) => {
    state.fetchRunDetailStatus = fetchStatuses.rejected;
    state.runDetailError = action.error;
  });

  builder.addCase(clearReconciliationRunDetail, (state) => {
    state.activeRunDetail = null;
    state.runDetailItems = [];
    state.runDetailTotalItems = 0;
    state.fetchRunDetailStatus = fetchStatuses.idle;
    state.runDetailError = null;
    state.exportReconciliationRunStatus = fetchStatuses.idle;
    state.reconciliationItemDetail = null;
    state.fetchReconciliationItemDetailStatus = fetchStatuses.idle;
    state.reconciliationItemDetailError = null;
  });

  builder.addCase(clearReconciliationRunItemDetail, (state) => {
    state.reconciliationItemDetail = null;
    state.fetchReconciliationItemDetailStatus = fetchStatuses.idle;
    state.reconciliationItemDetailError = null;
  });

  builder.addCase(fetchReconciliationRunItemDetail.pending, (state) => {
    state.fetchReconciliationItemDetailStatus = fetchStatuses.pending;
    state.reconciliationItemDetailError = null;
    state.reconciliationItemDetail = null;
  });
  builder.addCase(fetchReconciliationRunItemDetail.fulfilled, (state, action) => {
    state.reconciliationItemDetail = action.payload.data;
    state.fetchReconciliationItemDetailStatus = fetchStatuses.success;
    state.reconciliationItemDetailError = null;
  });
  builder.addCase(fetchReconciliationRunItemDetail.rejected, (state, action) => {
    state.fetchReconciliationItemDetailStatus = fetchStatuses.rejected;
    state.reconciliationItemDetailError = action.error;
  });

  builder.addCase(fetchReconciliationRunExportJson.pending, (state) => {
    state.exportReconciliationRunStatus = fetchStatuses.pending;
  });
  builder.addCase(fetchReconciliationRunExportJson.fulfilled, (state) => {
    state.exportReconciliationRunStatus = fetchStatuses.idle;
  });
  builder.addCase(fetchReconciliationRunExportJson.rejected, (state) => {
    state.exportReconciliationRunStatus = fetchStatuses.idle;
  });
});
